import React from 'react';
import { Target, Heart, Globe, Award } from 'lucide-react';
import { companyInfo, teamMembers, companyValues } from '../data/mock';

export const About = () => {
  return (
    <div className="bg-[#FAF8F3] pt-20">
      {/* About Hero */}
      <section className="section section-accent">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="section-title">About Pravak Global Exports</h1>
          <div className="accent-line mx-auto"></div>
          <p className="section-subtitle max-w-4xl mx-auto mt-6">
            {companyInfo.description}
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="section section-light">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="section-title text-3xl">Our Story</h2>
              <div className="accent-line"></div>
              <p className="body-text mb-6">
                Founded in {companyInfo.founded}, Pravak Global Exports was established with a vision to become a trusted name in India's leather export industry. Our journey began with three passionate entrepreneurs who recognized the immense potential of Indian leather craftsmanship in global markets.
              </p>
              <p className="body-text mb-6">
                Starting as a small export venture, we've built strong relationships with skilled artisans and quality-conscious manufacturers across India. Our commitment to excellence and ethical business practices has enabled us to establish a foundation for sustainable growth in the competitive international leather goods market.
              </p>
              <p className="body-text">
                Today, as we expand our operations, we remain focused on our core mission: delivering premium quality leather products that meet international standards while maintaining competitive pricing for our wholesale partners worldwide.
              </p>
            </div>
            <div className="bg-white p-2 border border-[#D4A574]">
              <img
                src="https://images.pexels.com/photos/6275977/pexels-photo-6275977.jpeg"
                alt="Leather Craftsmanship"
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section section-accent">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="section-title">Our Core Values</h2>
            <div className="accent-line mx-auto"></div>
            <p className="section-subtitle max-w-3xl mx-auto mt-6">
              These principles guide every decision we make and every partnership we build.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {companyValues.map((value, index) => {
              const icons = [Target, Heart, Globe, Award];
              const Icon = icons[index];
              return (
                <div key={value.id} className="bg-white p-8 border-l-4" style={{borderColor: '#8B4513'}}>
                  <div className="flex items-start gap-4">
                    <div style={{color: '#8B4513'}}>
                      <Icon size={40} />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-3" style={{color: '#2C1810'}}>{value.title}</h3>
                      <p className="body-text">{value.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Our Team - HIDDEN FOR NOW (uncomment when ready to show)
      <section className="section section-light">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="section-title">Meet Our Team</h2>
            <div className="accent-line mx-auto"></div>
            <p className="section-subtitle max-w-3xl mx-auto mt-6">
              A dedicated team of three professionals working together to bring you the finest leather goods from India.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={member.id} className="bg-white border border-[#D4A574] overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="bg-[#F5F1E8] flex items-center justify-center py-12">
                  <div className="w-32 h-32 rounded-full flex items-center justify-center" style={{background: '#8B4513'}}>
                    <span className="text-white text-5xl font-bold">
                      {index + 1}
                    </span>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-xl font-bold mb-2" style={{color: '#2C1810'}}>{member.name}</h3>
                  <p className="text-sm font-semibold mb-4" style={{color: '#8B4513', textTransform: 'uppercase', letterSpacing: '0.5px'}}>
                    {member.role}
                  </p>
                  <p className="body-text text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* Mission Statement */}
      <section className="section section-dark">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="section-title" style={{color: '#FAF8F3'}}>Our Mission</h2>
          <div className="accent-line mx-auto"></div>
          <p className="text-xl leading-relaxed mt-8" style={{color: '#D4A574'}}>
            To become a globally recognized name in leather goods export by consistently delivering premium quality products, maintaining ethical business practices, and building lasting partnerships with international clients who value craftsmanship and reliability.
          </p>
        </div>
      </section>
    </div>
  );
};